import { CreateUserApiError, CreateUserError } from './createUser.model';

export function createUserErrorAdapter(
  error: CreateUserApiError
): Promise<CreateUserError> {
  return Promise.reject(error.response?.data);
}
